import * as actionTypes from './actionsType';

export const getLessonsByGroupStart = (id) => ({
    type: actionTypes.GET_LESSONS_CARDS_START,
    id,
});

export const setLessonsCardsStart = (result) => ({
    type: actionTypes.SET_LESSONS_CARDS_START,
    result,
});

export const selectGroupId = (id) => ({
    type: actionTypes.SELECT_GROUP_ID,
    id,
});
